import { Box, Button, Container, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { IconCalendar, IconMapPin, IconUser, IconMessage } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

import type { JSX } from "react";

export function AppointmentConfirmation(): JSX.Element {
  const navigate = useNavigate();

  // This would come from the appointment scheduling flow
  const appointmentDetails = {
    date: 'Fri, Feb 21, 2025',
    time: '1:00 pm - 1:50 pm PST',
    provider: 'Albert Wong',
    type: 'Initial Intake Session',
    location: 'Online Services',
    address: '1 H Street #203',
    city: 'San Rafael, CA 94901-1750',
    phone: '(415) 545-8899'
  };

  return (
    <Container size="md" py="xl">
      <Paper p="xl" radius="md" withBorder>
        <Stack gap="md">
          <Box ta="center">
            <Title order={2} mb="sm">Your appointment has been requested!</Title>
            <Text c="dimmed">
              Your appointment is not confirmed until you get an email saying that your request has been accepted.
            </Text>
          </Box>

          <Stack gap="md">
            <Group align="flex-start">
              <IconCalendar size={24} />
              <Box>
                <Text fw={500}>When</Text>
                <Text>{appointmentDetails.date}</Text>
                <Text>{appointmentDetails.time}</Text>
              </Box>
            </Group>

            <Group align="flex-start">
              <IconUser size={24} />
              <Box>
                <Text fw={500}>Who</Text>
                <Text>{appointmentDetails.provider}</Text>
              </Box>
            </Group>

            <Group align="flex-start">
              <IconMessage size={24} />
              <Box>
                <Text fw={500}>What</Text>
                <Text>{appointmentDetails.type}</Text>
              </Box>
            </Group>

            <Group align="flex-start">
              <IconMapPin size={24} />
              <Box>
                <Text fw={500}>Where</Text>
                <Text>{appointmentDetails.location}</Text>
                <Text>{appointmentDetails.address}</Text>
                <Text>{appointmentDetails.city}</Text>
                <Text>{appointmentDetails.phone}</Text>
              </Box>
            </Group>
          </Stack>

          <Box>
            <Text fw={500} mb="xs">Add to Calendar</Text>
            <Group>
              <Button variant="light" size="sm">GOOGLE</Button>
              <Button variant="light" size="sm">APPLE</Button>
              <Button variant="light" size="sm">OUTLOOK</Button>
            </Group>
          </Box>

          <Group mt="xl">
            <Button variant="light" color="red" onClick={() => navigate('/appointments')}>
              CANCEL APPOINTMENT
            </Button>
            <Button onClick={() => navigate('/appointments')}>
              DONE
            </Button>
          </Group>
        </Stack>
      </Paper>
    </Container>
  );
}